


<template>
  <div>

        <el-form class="select" style="display: flex; flex-wrap: wrap;">

            <!-- <el-form-item label="教师姓名:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择"   v-model="teacherName"  style="width: 100%" clearable  filterable  >
                <el-option v-for="item in teacherArr"  :key="item.id"  :value="item.id"  :label="item.realname" >  </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="学科组:" label-width="100px" style="width: 30%;" >
              <el-select  placeholder="请选择学科组"  v-model="SubjectGroup"  style="width: 100%" clearable  filterable  >
                 <el-option v-for="item in SubjectGroupList" :key="item.id" :label="item.teacherName"  :value="item.id"></el-option>
              </el-select>
            </el-form-item>


            <!-- <el-form-item label="老师状态:" label-width="100px" style="width: 30%;" v-if="isMub != 3">
              <el-select v-model="teacherStatus"  filterable placeholder="请选择老师状态"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in teacherStatusList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="学生类型:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择所在地域"  v-model="regionName"  style="width: 100%"   clearable  filterable  >
                <el-option  v-for="item in optionsListt" :key="item.id"  :value="item.dictType"  :label="item.dictValue"  >  </el-option>
              </el-select>
            </el-form-item>

            <el-form-item 
              :label="
                  isMub === 1 ? '首次课日期' : 
                  isMub === 2 ? '新增课日期' :
                  isMub === 3 ? '上课日期' :
                  isMub === 4 ? '上课日期' :
                  isMub === 5 ? '流失日期' : '续报日期'
              " 
              label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker v-model="dateTimeList"   type="daterange"  style="width: 100%;"   value-format="yyyy-MM-dd"   range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期">   </el-date-picker>
            </el-form-item>

            <el-form-item label="计算方式:" label-width="100px" style="width: 30%;" v-if="isMub === 3">
              <el-select v-model="courseType"  filterable placeholder="请选择计算方式"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in courseTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>
            
        </el-form>


        <div style=" text-align: end; padding: 10px;">
          <el-button @click="handleClear" icon="el-icon-close" size="small" class="btns">清除</el-button>
          <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
          <el-button type="primary" icon="el-icon-download" size="small" class="btns" @click="handleDownload">导出</el-button>
        </div>



    <div style="margin-top: 15px;margin-bottom: 20px;" v-if="isMub != 2 && isMub != 4  && isMub != 5">

      <div style="display: flex;justify-content: space-between;margin-bottom: 10px;margin-top: 10px;" v-for="(item,index) in dateList" :key="index" class="chart-item">
       
        <el-card style="width: 23%; border-radius: 15px;">
            <div style="text-align: start;">{{ fonttype.name1 }}</div>

            <div style="font-size: 35px;font-weight: 900;text-align: start;" v-if="isMub === 2 || isMub === 4 || isMub === 5">{{ item.entiretyNumber ? item.entiretyNumber : 0 }} / {{ item.entiretyNumPercentage ? item.entiretyNumPercentage : 0 }} </div>
            <div style="font-size: 35px;font-weight: 900;text-align: start;" v-if="isMub === 3"> {{ item.entiretyNumber ? item.entiretyNumber : 0  }} </div>
            <div style="font-size: 40px;font-weight: 900;text-align: start;" v-if="isMub === 1">{{ item.endingNumber ? item.endingNumber : 0 }}</div>

            <div style="display: flex; margin-top: 10px;">
              <div style="color: #989090;font-size: 13px;"  v-if="isMub === 4 || isMub === 5">{{ calculationType === 1  ?  '差异率' : calculationType === 2  ?  '差值' : '差异率' }}</div>
              <div style="padding-top: 2px;padding-left: 3px;"  :style="{ color:item.endingType === '1' ?  'rgb(45 202 46)' : item.endingType === '2' ? '#ed1313' : ''}">
                <i :class="{ 'el-icon-caret-top': item.endingType === '1',  'el-icon-caret-bottom': item.endingType === '2' , 'el-icon-minus': item.endingType === '3',}"></i>
                <span>{{ calculationType === 1 ? item.endingPercentage : calculationType === 2 ? item.endingDiff : '' }}</span>
              </div>
            </div>
        </el-card>

        <el-card style="width: 23%; border-radius: 15px;">
            <div style="text-align: start;">{{ fonttype.name2 }}</div>
           
            <div style="font-size: 35px;font-weight: 900;text-align: start;" v-if="isMub === 2 || isMub === 4 || isMub === 5">{{ item.offlineNumber ? item.offlineNumber : 0 }} / {{ item.offlineNumPercentage ? item.offlineNumPercentage : 0 }}</div>
            <div style="font-size: 35px;font-weight: 900;text-align: start;" v-if="isMub === 3"> {{ item.offlineNumber ? item.offlineNumber : 0  }} </div>
            <div style="font-size: 40px;font-weight: 900;text-align: start;" v-if="isMub === 1">{{ item.studentNumber ? item.studentNumber : 0 }}</div>

            <div style="display: flex; margin-top: 10px;">
              <div style="color: #989090;font-size: 13px;"  v-if="isMub === 4 || isMub === 5">{{ calculationType === 1  ?  '差异率' : calculationType === 2  ?  '差值' : '差异率' }}</div>
              <div style="padding-top: 2px;padding-left: 3px;"  :style="{ color:item.studentType === '1' ?  'rgb(45 202 46)' : item.studentType === '2' ? '#ed1313' : ''}">
                <i :class="{ 'el-icon-caret-top': item.studentType === '1',  'el-icon-caret-bottom': item.studentType === '2', 'el-icon-minus': item.studentType === '3', }"></i>
                <span>{{ calculationType === 1 ? item.studentPercentage : calculationType === 2 ? item.studentDiff : '' }}</span>
              </div>
            </div>
        </el-card>

        <el-card style="width: 23%; border-radius: 15px;">
            <div style="text-align: start;">{{ fonttype.name3 }}</div>

            <div style="font-size: 35px;font-weight: 900;text-align: start;" v-if="isMub === 2 || isMub === 4 || isMub === 5">{{ item.projectNumber ? item.projectNumber : 0 }} / {{ item.projectNumPercentage ? item.projectNumPercentage : 0 }}</div>
            <div style="font-size: 35px;font-weight: 900;text-align: start;" v-if="isMub === 3"> {{ item.projectNumber ? item.projectNumber : 0  }}</div>
            <div style="font-size: 40px;font-weight: 900;text-align: start;" v-if="isMub === 1">{{ item.classNumber ? item.classNumber : 0 }}</div>

            <div style="display: flex; margin-top: 10px;">
              <div style="color: #989090;font-size: 13px;"  v-if="isMub === 4 || isMub === 5">{{ calculationType === 1  ?  '差异率' : calculationType === 2  ?  '差值' : '差异率' }}</div>
              <div style="padding-top: 2px;padding-left: 3px;"  :style="{ color:item.classType === '1' ?  'rgb(45 202 46)' : item.classType === '2' ? '#ed1313' : ''}">
                <i :class="{ 'el-icon-caret-top': item.classType === '1',  'el-icon-caret-bottom': item.classType === '2', 'el-icon-minus': item.classType === '3', }"></i>
                <span>{{ calculationType === 1 ? item.classPercentage : calculationType === 2 ? item.classDiff : '' }}</span>
              </div>
            </div>
        </el-card>

        <el-card style="width: 23%; border-radius: 15px;">
            <div style="text-align: start;">{{ fonttype.name4 }}</div>

            <div style="font-size: 35px;font-weight: 900;text-align: start;" v-if="isMub === 2 || isMub === 4 || isMub === 5 ">{{ item.cramNumber ? item.cramNumber : 0 }} / {{ item.cramNumPercentage ? item.cramNumPercentage : 0 }}</div>
            <div style="font-size: 35px;font-weight: 900;text-align: start;" v-if="isMub === 3">  {{ item.cramNumber ? item.cramNumber : 0  }}</div>
            <div style="font-size: 40px;font-weight: 900;text-align: start;" v-if="isMub === 1">{{ item.categoryNumber ? item.categoryNumber : 0 }}</div>

            <div style="display: flex; margin-top: 10px;">
              <div style="color: #989090;font-size: 13px;" v-if="isMub === 4 || isMub === 5">{{ calculationType === 1  ?  '差异率' : calculationType === 2  ?  '差值' : '差异率' }}</div>
              <div style="padding-top: 2px;padding-left: 3px;"  :style="{ color:item.categoryType === '1' ?  'rgb(45 202 46)' : item.categoryType === '2' ? '#ed1313' : ''}">
                <i :class="{ 'el-icon-caret-top': item.categoryType === '1',  'el-icon-caret-bottom': item.categoryType === '2', 'el-icon-minus': item.categoryType === '3', }"></i>
                <span>{{ calculationType === 1 ? item.categoryPercentage : calculationType === 2 ? item.categoryDiff : '' }}</span>
              </div>
            </div>
        </el-card>

      </div>

    </div>


    <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataTableList" border height="700">
        <el-table-column prop="subjectGroupName" header-align="center"  label="学科组" ></el-table-column>
        <el-table-column   prop="manageName" header-align="center"  label="学管姓名" ></el-table-column>

        <el-table-column  v-if="isMub === 3 " prop="regionNames" header-align="center"  label="所属地域" ></el-table-column>
        <el-table-column prop="entirety" header-align="center"  label="整体课数量" v-if="isMub === 1"></el-table-column>
        <el-table-column prop="offline" header-align="center"  label="线下课数量" v-if="isMub === 1"></el-table-column>
        <el-table-column prop="project" header-align="center"  label="规划课数量" v-if="isMub === 1"></el-table-column>

        <el-table-column prop="" header-align="center"  label="整体课数/率" v-if="isMub === 2 ">
          <template slot-scope="scope">
            <span> {{ scope.row.entiretyNumber ? scope.row.entiretyNumber : 0 }} / {{ scope.row.entiretyNumPercentage ? scope.row.entiretyNumPercentage : 0 }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="" header-align="center"  label="线下课数/率" v-if="isMub === 2 ">
          <template slot-scope="scope">
            <span> {{ scope.row.offlineNumber ? scope.row.offlineNumber : 0 }} / {{ scope.row.offlineNumPercentage ? scope.row.offlineNumPercentage : 0  }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="" header-align="center"  label="规划课数/率" v-if="isMub === 2 ">
          <template slot-scope="scope">
            <span> {{ scope.row.projectNumber ? scope.row.projectNumber : 0 }} / {{ scope.row.projectNumPercentage ? scope.row.projectNumPercentage : 0 }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="" header-align="center"  label="纯补课数/率" v-if="isMub === 2 ">
          <template slot-scope="scope">
            <span> {{ scope.row.cramNumber ? scope.row.cramNumber : 0 }} / {{ scope.row.cramNumPercentage ? scope.row.cramNumPercentage : 0 }} </span>
          </template>
        </el-table-column>

        <el-table-column prop="entiretyNumber" header-align="center"  label="整体到课率" v-if="isMub === 3"></el-table-column>
        <el-table-column prop="offlineNumber" header-align="center"  label="线下到课率" v-if="isMub === 3"></el-table-column>
        <el-table-column prop="projectNumber" header-align="center"  label="规划到课率" v-if="isMub === 3"></el-table-column>
        <el-table-column prop="cramNumber" header-align="center"  label="纯补课到课率" v-if="isMub === 3"></el-table-column>

        <el-table-column prop="entiretyNumber" header-align="center"  label="取消课总数/率" v-if="isMub === 4">
          <template slot-scope="scope">
            <span> {{ scope.row.entiretyNumber }} / {{ scope.row.entiretyNumPercentage }} </span>
          </template> 
        </el-table-column>
        <el-table-column prop="offlineNumber" header-align="center"  label="线下取消课数/率" v-if="isMub === 4">
          <template slot-scope="scope">
            <span> {{ scope.row.offlineNumber }} / {{ scope.row.offlineNumPercentage }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="projectNumber" header-align="center"  label="规划取消课数/率" v-if="isMub === 4">
          <template slot-scope="scope">
            <span> {{ scope.row.projectNumber }} / {{ scope.row.projectNumPercentage }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="cramNumber" header-align="center"  label="纯补课取消课数/率" v-if="isMub === 4">
          <template slot-scope="scope">
            <span> {{ scope.row.cramNumber }} / {{ scope.row.cramNumPercentage }} </span>
          </template> 
        </el-table-column>

        <el-table-column prop="familyHourResidue" header-align="center"  label="整体流失数/率" v-if="isMub === 5">
          <template slot-scope="scope">
            <span> {{ scope.row.entiretyNumber }} / {{ scope.row.entiretyNumPercentage }} </span>
          </template> 
        </el-table-column>
        <el-table-column prop="familyHourYet" header-align="center"  label="线下流失数/率" v-if="isMub === 5">
          <template slot-scope="scope">
            <span> {{ scope.row.offlineNumber }} / {{ scope.row.offlineNumPercentage }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="familyHourNumber" header-align="center"  label="规划流失数/率" v-if="isMub === 5">
          <template slot-scope="scope">
            <span> {{ scope.row.projectNumber }} / {{ scope.row.projectNumPercentage }} </span>
          </template> 
        </el-table-column>
        <el-table-column prop="familyHourNumber" header-align="center"  label="纯补课流失数/率" v-if="isMub === 5">
          <template slot-scope="scope">
            <span> {{ scope.row.cramNumber }} / {{ scope.row.cramNumPercentage }} </span>
          </template>
        </el-table-column>

        <el-table-column prop="cram" header-align="center"  label="纯补课课数量" v-if="isMub === 1"></el-table-column>

        <el-table-column header-align="center" label="查看详情" width="150px">
          <template slot-scope="scope">
            <el-button type="text" @click="details(scope.row)">详情</el-button>
          </template>
        </el-table-column>
    </el-table>


     <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :current-page="pageNum" :page-size="pageSize"  
        layout="prev, pager, next,sizes, jumper" :total="total">
     </el-pagination>


    <el-dialog width="80%" :visible.sync="showPopUpNotification" :before-close="showPopUpNotificationCler" :close-on-click-modal="false" modal-append-to-body :append-to-body="true">
        <component v-if="showPopUpNotification" :is="isComponents" :paramsComponents="params_ZUJIAN" :isMub="isMub" :TabsType="TabsType"></component>
    </el-dialog>

   
  </div>
</template>



<script>

import axios from "axios";
import apiBaseUrl from "../../../config/api";
import { getTeachers_s,getTeachers_ss  } from "@/api/firstClassApi";
import * as echarts from 'echarts';
import loadingUtils from "../../utils/loading";
import fistClassComponents from '../fistClass.vue';
import feedBackComponents from '../feedBack.vue';
import asYouPleaseComponents from '../asYouPlease.vue';
import TurnoverRateDetails from '../TurnoverRateDetails.vue';



export default {
  name: 'FistClassTableTeacherStart',
  components: {
    fistClassComponents,
    feedBackComponents,
    asYouPleaseComponents,
    TurnoverRateDetails,
  },
  props: {
    type: {
      type: String,
      default: '未知'
    },
  },
  data() {
    return {

      isComponents: '',

      teacherName: '',
      teacherArr: [],

      TabsType: 'teacher', 

      newClassType: '',
      newClassTypeList: [
        {id:1,name:'规划'},
        {id:2,name:'线下'},
        {id:3,name:'纯补课'},
      ],

      teacherStatusList: [
        {id:1,name:'在职'},
        {id:2,name:'离职'},
        {id:5,name:'全部'}
      ],

      teacherStatus: 5,

      regionName: '',
      optionsListt: [],

      dateTimeList: [],


      showPopUpNotification: false,
      params_ZUJIAN: null,



      dateList: [], // 用于存储日期列表
      calculationType: 1, // 1: 差异率, 2: 差值, 3: 无差异率


      dataTableList: [], // 用于存储表格数据

      pageSize: 10,
      pageNum: 1,
      total: 0,


      courseType: 1,
      courseTypeList:[
        {
          name: '按周计算',
          id: 1
        },
        {
          name: '按月计算',
          id: 2
        }
      ],



      fonttype: {
          name1: '',
          name2: '',
          name3: '',
          name4: ''
      },

      isMub: 0, 
      SubjectGroupList: [],
      SubjectGroup:'',


    }
  },

  computed: {
   
  },

  mounted() {
    this.SubjectGroupList = JSON.parse(sessionStorage.getItem('SubjectGroupList'))
    

    let typeFont = this.type === '首次课图表' ? '首次课渠道占比' : 
                        this.type === '新增率图表' ? '新增课渠道占比' : 
                          this.type === '到课率图表' ? '到课率渠道占比' : 
                            this.type === '取消率图表' ? '取消课渠道占比' : 
                              this.type === '流失率图表' ? '流失课渠道占比' : ''

    this.isMub = this.type === '首次课图表' ? 1 : 
                    this.type === '新增率图表' ? 2 : 
                       this.type === '到课率图表' ? 3 : 
                          this.type === '取消率图表' ? 4 : 
                            this.type === '流失率图表' ? 5 : 0


    if(typeFont === '首次课渠道占比'){
        this.fonttype = {   name1: '首次课总数', name2: '线下', name3: '规划', name4: '纯补课'  }
    }
    
    if(typeFont === '新增课渠道占比'){
        this.fonttype = {   name1: '新增课总数/率', name2: '线下新增课数/率', name3: '规划新增课数/率', name4: '纯补课新增课数/率'  }
    }

    if(typeFont === '到课率渠道占比'){
       this.fonttype = {   name1: '整体到课率', name2: '线下到课率', name3: '规划到课率', name4: '纯补课到课率'  }
    }

    if(typeFont === '取消课渠道占比'){
       this.fonttype = {   name1: '取消课总数/率', name2: '线下取消课数/率', name3: '规划取消课数/率', name4: '纯补课取消课数/率'  }
    }

    if(typeFont === '流失课渠道占比'){
       this.fonttype = {   name1: '整体流失数/率', name2: '线下流失数/率', name3: '规划流失数/率', name4: '纯补课流失数/率'  }
    }



    getTeachers_ss().then((res) => {  this.teacherArr = res.data   })
    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
       this.optionsListt = res.data.data
    })


    // this.handleGetDateTime();

    if(this.isMub === 3){
      this.handleGetDateTime();
    }else{
      this.dateTimeList = this.getDefaultDateRange()
    }
    // this.dateTimeList = this.getDefaultDateRange() 
    
    this.handleGetDateList();

  },
  

  methods: {

    handleGetDateTime(){
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();
      const currentDate = now.getDate();
      const currentDay = now.getDay();
      const lastMonday = new Date(currentYear, currentMonth, currentDate - currentDay - 6);
      const lastSunday = new Date(currentYear, currentMonth, currentDate - currentDay);
      const lastMondayFormatted = `${lastMonday.getFullYear()}-${lastMonday.getMonth() + 1 < 10 ? '0' + (lastMonday.getMonth() + 1) : lastMonday.getMonth() + 1}-${lastMonday.getDate() > 10 ? lastMonday.getDate() : '0' + lastMonday.getDate()}`;
      const lastSundayFormatted = `${lastSunday.getFullYear()}-${lastSunday.getMonth() + 1 < 10 ? '0' + (lastSunday.getMonth() + 1) : lastSunday.getMonth() + 1}-${lastSunday.getDate() > 10 ? lastSunday.getDate() : '0' + lastSunday.getDate()}`;
      this.dateTimeList = [lastMondayFormatted, lastSundayFormatted];
      
      this.courseType = 1
      
    },

    formatDate(date) {
          const y = date.getFullYear();
          let m = date.getMonth() + 1; // Months are zero based
          let d = date.getDate();
          m = m < 10 ? '0' + m : m;
          d = d < 10 ? '0' + d : d;
          return `${y}-${m}-${d}`;
    },


    getDefaultDateRange() {
        const today = new Date();
        const year = today.getFullYear();
        let startMonth = today.getMonth() - 6; // 半年前的月份
        let startYear = year;
        
        // 调整年份和月份，确保开始月份正确
        if (startMonth < 0) {
            startMonth += 12;
            startYear -= 1;
        }
        
        // 开始日期总是当月的第一天
        const startDate = new Date(startYear, startMonth, 1);
        
        // 结束日期是当前月份的最后一天
        const endYear = today.getFullYear();
        const endMonth = today.getMonth();
        const endDate = new Date(endYear, endMonth + 1, 0); // 0表示前一个月的最后一天

        this.courseType = 1
        return [this.formatDate(startDate), this.formatDate(endDate)];
      },

    handleSizeChange(e){
       this.pageSize = e
       this.handleGetDateList()
    },

    handleCurrentChange(e){
       this.pageNum = e
       this.handleGetDateList()
    },


    showPopUpNotificationCler() {
      this.params_ZUJIAN = null;
      this.showPopUpNotification = false;
    },


    details(row) {
      
      this.isComponents =  this.isMub === 1 ? 'fistClassComponents' : 
                             this.isMub === 2 ? 'feedBackComponents' : 
                              this.isMub === 3 ? 'feedBackComponents' : 
                               this.isMub === 4 ? 'asYouPleaseComponents' : 
                                this.isMub === 5 ? 'TurnoverRateDetails' : 'fistClassComponents'

      row.dateTimeList = this.dateTimeList.length > 1 ? this.dateTimeList : [],
      row.courseType = this.courseType,
      this.params_ZUJIAN = {
        teacherId:row.teacherId,
        startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
        endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
        regionName: this.regionName,
        classType: this.newClassType,
        courseType:this.courseType,
        teacherStatus: this.teacherStatus,
        subjectGroupId: row.subjectGroupId,
      };
      this.showPopUpNotification = true;
    },

    handleSearch() {
      this.pageNum = 1
      this.pageSize = 10
      this.handleGetDateList();

    },

    handleClear() {
      this.SubjectGroup = ''
      this.teacherName = '';
      this.newClassType = '';
      this.teacherStatus = 5
      this.regionName = '';
      // this.dateTimeList = this.getDefaultDateRange() ;
      // this.handleGetDateTime()
      this.pageSize = 10
      this.pageNum = 1
      this.total = 0
      this.courseType = 1
      // this.dateTimeList = this.getDefaultDateRange() 


      if(this.isMub === 3){
        this.handleGetDateTime();
      }else{
        this.dateTimeList = this.getDefaultDateRange()
      }

      
      this.handleGetDateList();
    },

    handleDownload(){

      loadingUtils.startLoading();

      let data = { 
          pageIndex: this.pageNum,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
          endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
          teacherId: this.teacherName,
          regionName: this.regionName,
          monthWeekType: this.courseType,
          classType: this.newClassType,
          teacherStatus: this.teacherStatus,
          subjectGroupId: this.SubjectGroup,
          exportType: 1
      }

      let url = this.type === '首次课图表' ? '/firstRecordDiagram/exportSubjectFirstDiagram' :
                  this.type === '新增率图表' ? '/classSales/exportStatistics' :
                    this.type === '到课率图表' ? '/scheduleComplete/exportTeacherSchedule' :
                      this.type === '取消率图表' ? '/lossCourseDiagram/queryTeacherCourseDiagram' :
                        this.type === '流失率图表' ? '/classSales/exportStatistics' :
                          this.type === '续报率图表' ? '/continuedReport/queryTeacherContinuedReportDiagram' : '/classSales/exportStatistics'

      let xlsxName = this.type === '首次课图表' ? '首次课学科组统计数据' :
                        this.type === '新增率图表' ? '新增率图表' :
                          this.type === '到课率图表' ? '到课率图表' :
                            this.type === '取消率图表' ? '取消率图表' :
                              this.type === '流失率图表' ? '流失率图表' :
                                this.type === '续报率图表' ? '续报率图表' : ''



      axios.post(`${apiBaseUrl}${url}`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((response) => {
        const blob = new Blob([response.data], { type: "application/vnd.ms-excel"})
      
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)

        const downloadLink = document.createElement("a")
        downloadLink.href = URL.createObjectURL(blob)
        downloadLink.download =  xlsxName + ".xlsx"
        downloadLink.click()
      }).catch((error) => {
        this.$message.error(error)
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)
      })

    },

    handleGetDateList(){

      loadingUtils.startLoading();

      let data = {

          pageIndex: this.pageNum,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
          endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
          teacherId: this.teacherName,
          regionName: this.regionName,
          monthWeekType: this.courseType,
          classType: this.newClassType,
          teacherStatus: this.teacherStatus,
          subjectGroupId: this.SubjectGroup,
          // teacherName: this.teacherName,
      }


     let url = this.type === '首次课图表' ? '/firstRecordDiagram/querySubjectFirstDiagramNum' :
                  this.type === '新增率图表' ? '/newCourseDiagram/queryTeacherCourseDiagram' :
                    this.type === '到课率图表' ? '/scheduleComplete/queryScheduleCompleteTeacher' :
                      this.type === '取消率图表' ? '/cancelCourseDiagram/queryTeacherCourseDiagram' :
                        this.type === '流失率图表' ? '/lossCourseDiagram/queryTeacherCourseDiagram' :
                          this.type === '续报率图表' ? '/classSales/queryStatistics' : '/classSales/queryStatistics'


     
      axios.post(`${apiBaseUrl}${url}`, data ,{ headers: {'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
         if(res.data.code === 200){
            if(res.data.code === 200){

              let datas = null 
              let obj = {}
              if(this.type === '首次课图表' || this.type === '新增率图表'){
                datas = res.data.data.entity
                obj = {
                    endingNumber: datas.entiretyStatistics,
                    studentNumber: datas.offlineStatistics,
                    classNumber: datas.projectStatistics,
                    categoryNumber: datas.cramStatistics,
                }

                this.dateList = [obj]
                this.dataTableList = datas.subjectFirstDiagramStatistics
                this.total = res.data && res.data.data.allTotal ? res.data.data.allTotal : 0
                this.pageSize = res.data && res.data.data.pageSize ? res.data.data.pageSize : 10
                this.pageNum = res.data && res.data.data.pageIndex ? res.data.data.pageIndex : 1
              }

              if(this.type === '到课率图表'){
                datas = res.data.data
                obj = {
                    entiretyNumber: datas.scheduleCompleteTeacherCountDto.entiretyNumber,
                    offlineNumber: datas.scheduleCompleteTeacherCountDto.offlineNumber,
                    projectNumber: datas.scheduleCompleteTeacherCountDto.projectNumber,
                    cramNumber: datas.scheduleCompleteTeacherCountDto.cramNumber,
                }

                this.dateList = [obj]
                this.dataTableList = datas.resultIpage.records
                this.total = datas.resultIpage && datas.resultIpage.total ? datas.resultIpage.total : 0
                this.pageSize = datas.resultIpage && datas.resultIpage.size ? datas.resultIpage.size : 10
                this.pageNum = datas.resultIpage && datas.resultIpage.current ? datas.resultIpage.current : 1
              }


              if(this.type === '取消率图表'){
                datas = res.data.data.entity
                obj = {
                    endingNumber: datas.entiretyStatistics,
                    studentNumber: datas.offlineStatistics,
                    classNumber: datas.projectStatistics,
                    categoryNumber: datas.cramStatistics,
                }

                this.dateList = [obj]
                this.dataTableList = datas
                this.total = res.data && res.data.data.allTotal ? res.data.data.allTotal : 0
                this.pageSize = res.data && res.data.data.pageSize ? res.data.data.pageSize : 10
                this.pageNum = res.data && res.data.data.pageIndex ? res.data.data.pageIndex : 1
              }


              if(this.type === '流失率图表'){
                datas = res.data.data.entity
                obj = {
                    endingNumber: datas.entiretyStatistics,
                    studentNumber: datas.offlineStatistics,
                    classNumber: datas.projectStatistics,
                    categoryNumber: datas.cramStatistics,
                }

                this.dateList = [obj]
                this.dataTableList = datas
                this.total = res.data && res.data.data.allTotal ? res.data.data.allTotal : 0
                this.pageSize = res.data && res.data.data.pageSize ? res.data.data.pageSize : 10
                this.pageNum = res.data && res.data.data.pageIndex ? res.data.data.pageIndex : 1
              }
              
              


              if(this.type === '新增率图表'){
                if(res.data.data && res.data.data.entity.length > 0){
                   const [first, ...rest] = res.data.data.entity;
                   console.log(first, ...rest)
                   this.dateList = [first]
                   this.dataTableList = res.data.data.entity
                }else{
                   this.dateList = []
                   this.dataTableList = []
                }
              }

            

              console.log(this.dateList, 'this.dateList')
              
              setTimeout(() => {
                loadingUtils.endLoading()
              }, 500)


              let arr = []

              datas.teacherFirstDiagramStatistics && datas.teacherFirstDiagramStatistics.length > 1 ? datas.teacherFirstDiagramStatistics.map((item) => {
                  console.log(item)
                  arr.push({
                    channelOfflineNumber: Number(item.channelOfflineNumber),
                    channelMakeNumber: Number(item.channelMakeNumber),
                    channelProjectNumber: Number(item.channelProjectNumber),
                  })
              })
              : []
              
              this.chartData = arr.length > 0 ? arr : []

              // this.$nextTick(() => {
              //     this.initCharts()
              // })

            }else{
              setTimeout(() => {
                loadingUtils.endLoading()
                this.dateList = []
                this.chartData = []
                this.$message({ type: 'error', message: res.data.message ? res.data.message : '出错了，请联系管理员~'  })
              }, 500)
            }
         }else{
             setTimeout(() => {
              loadingUtils.endLoading()
              this.dateList = []
              this.chartData = []
              this.$message({ type: 'error', message: res.data.message ? res.data.message : '出错了，请联系管理员~'  })
            }, 500)
         }
      }).catch(err => {
         this.dateList = []
         this.chartData = []
         this.$message({ type: 'error', message: err.message ? err.message : '出错了，请联系管理员~'  })
          setTimeout(() => {
            loadingUtils.endLoading()
          }, 500)
      })

    },

   

  },


  initCharts() {


      loadingUtils.startLoading();
      const charts = document.querySelectorAll('.chart-item  div[id^="chart-"]')


      this.$nextTick(()=>{
        charts.forEach((chart, index) => {

          if (!this.dateList[index]) return;

          let chartInstance = echarts.init(chart)
          let option = this.getChartOption(index)
          option && chartInstance.setOption(option)


            // params 包含点击的数据项信息
          chartInstance.on('click', params => {
              console.info(params);
              this.params_ZUJIAN = params;
              this.showPopUpNotification = true;
          });

          window.addEventListener('resize', () => {
            chartInstance.resize();
          })

        })

        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)

      })

    },


}


</script>




<style  scoped>

.btns{
   background-color: #428BCA;
   border-color: #428BCA;
   color: #fff;
}



</style>




// WEBPACK FOOTER //
// src/CourseTypeAnalysisEchart/FistClassTable/FistClassTableTeacherStartcopy.vue